import React from 'react'
import { Link } from 'react-router-dom';

export const Product = (props) => {
    const {product} = props;
    return (
        <div key={product._id} className="card">
            <Link to={`/product/${product._id}`} className="text-center">
                <img
                className="img-fluid"
                style={{
                    height: 220,
                  }}
                src={product.image ? product.image : "/logo512.png"}
                alt={product.name}
                />
            </Link>
            <div className="card-body">
                <Link to={`/product/${product._id}`}>
                <h2>{product.name}</h2>
                </Link>                 
                <div className="price">{product?.price?.toFixed(2).replace('.', ',')} €</div>
            </div>
        </div>
    )
}
